{
  "screen": {
    "heading": "Ändra läkemedelsordination",
    "open": "Ändra ordination",
    "openNamed": "Ändra ordination: {substance}",
    "explanation": "För en ordination där doseringen blev fel i journalen. Det som ändras är dos, administrationsväg, dosering, indikation, slutdatum och status.",
    "notPrescribing": "Det här är ingen ny ordination. Läkemedel ordineras inte i den här versionen — en ordination som inte finns i journalen kan inte läggas till här.",
    "inherited": "Läkemedel, styrka, beredningsform, ordinationsdatum och ordinatör hör till ordinationen och ändras inte.",
    "appendOnly": "Den nuvarande versionen tas inte bort. Det du sparar blir en ny version, och båda finns kvar i journalen med vem som skrev dem.",
    "requiredHint": "Fält utan anmärkning måste fyllas i.",
    "optional": "frivilligt",
    "save": "Spara ändringen",
    "saving": "Sparar …",
    "cancel": "Avbryt",
    "close": "Stäng",
    "discardQuestion": "Stäng formuläret? Det du har ändrat sparas inte.",
    "discardConfirm": "Stäng utan att spara",
    "discardCancel": "Fortsätt fylla i",
    "saved": "Ändringen är sparad."
  },
  "field": {
    "status": "Status",
    "doseUnit": "Enhet",
    "isPrn": "Vid behov",
    "prnMaxDose24h": "Högsta dos per dygn",
    "endAt": "Till och med",
    "prescriber": "Ordinatör"
  },
  "fieldHint": {
    "doseAmount": "Skriv dosen med punkt som decimaltecken: 0.25. Komma godtas inte.",
    "doseUnit": "Metrisk enhet, till exempel mg, g eller mikrogram. Skriv mikrogram helt — µg och mcg godtas inte. IE används för internationella enheter.",
    "route": "Hur läkemedlet ges, med den benämning som används här.",
    "frequency": "Doseringen i ord, till exempel 1 x 2.",
    "isPrn": "Markera om ordinationen gäller vid behov. Då måste högsta dos per dygn fyllas i.",
    "prnMaxDose24h": "Skriv taket som det är ordinerat, till exempel Max 4 doser per dygn. Journalen räknar inte ut det.",
    "indication": "Ordinationsorsak. Obligatorisk enligt HSLF-FS 2017:37.",
    "endAt": "Skriv som ÅÅÅÅ-MM-DD TT:MM med 24-timmarsklocka, till exempel 2026-10-15 08:00. Lämna tom för en ordination utan slutdatum. Datumet måste ligga efter ordinationsdatumet.",
    "status": "Välj Utsatt för en ordination som har avslutats, och Felaktigt införd bara när ordinationen aldrig gällde."
  },
  "status": {
    "active": "Aktuell",
    "completed": "Avslutad enligt plan",
    "stopped": "Utsatt",
    "enteredInError": "Felaktigt införd"
  },
  "refusal": {
    "doseMissing": "Dosen måste fyllas i. Ändringen sparades inte.",
    "doseComma": "Skriv dosen med punkt som decimaltecken: 0.25, inte 0,25. Ändringen sparades inte.",
    "doseMalformed": "Dosen läses inte som ett tal. Skriv den med siffror och punkt som decimaltecken: 0.25. Ändringen sparades inte.",
    "doseNotPositive": "Dosen måste vara större än noll. Ändringen sparades inte.",
    "unitMissing": "Enheten måste fyllas i. En dos utan enhet går inte att läsa. Ändringen sparades inte.",
    "unitNotMetric": "Enheten är inte metrisk. Använd mg, g, ml, mikrogram eller IE. Ändringen sparades inte.",
    "unitMicrogramAbbreviated": "Skriv mikrogram helt. µg och mcg förväxlas med mg, och skillnaden är tusen gånger. Ändringen sparades inte.",
    "statusInvalid": "Statusen känns inte igen. Ändringen sparades inte.",
    "fieldMissing": "{field} måste fyllas i. Ändringen sparades inte.",
    "fieldTooLong": "{field} är för långt. Högst {maximum} tecken. Ändringen sparades inte.",
    "isPrnMissing": "Formuläret skickade inte med om ordinationen gäller vid behov. Ändringen sparades inte.",
    "prnMaxDoseMissing": "En ordination vid behov måste ha en högsta dos per dygn. Skriv taket som det är ordinerat — journalen räknar inte ut det. Ändringen sparades inte.",
    "endAtMalformed": "Slutdatumet läses inte som en tidpunkt. Skriv det som ÅÅÅÅ-MM-DD TT:MM, till exempel 2026-10-15 08:00. Ändringen sparades inte.",
    "endBeforeStart": "Slutdatumet ligger före ordinationsdatumet {start}. Ändringen sparades inte.",
    "notFound": "Ordinationen finns inte i journalen. Ändringen sparades inte. Öppna patientöversikten igen.",
    "retracted": "Ordinationen är makulerad i journalen och kan inte ändras. Ändringen sparades inte.",
    "versionStale": "Någon annan har sparat en ny version av ordinationen medan formuläret var öppet. Öppna patientöversikten igen och kontrollera vad som står där. Det du skrev sparades inte.",
    "noChange": "Inget är ändrat jämfört med journalen. Ingen ny version skrevs.",
    "supersedesMissing": "Formuläret vet inte vilken version det utgår från. Stäng patientöversikten och öppna den igen. Ändringen sparades inte.",
    "patientNotFound": "Patienten finns inte i journalen. Ändringen sparades inte.",
    "patientRetracted": "Patienten är makulerad i journalen. Ändringen sparades inte.",
    "roleMayNotDocument": "Din roll får inte dokumentera i journalen. Ändringen sparades inte.",
    "unknown": "Ändringen sparades inte. Försök igen.",
    "unavailable": "Ingen kontakt med servern. Ändringen sparades inte — låt formuläret vara öppet och försök igen."
  }
}
